export default "__VITE_ASSET__D2mV5INW__"